<div class="md:px-5 md:py-5 p-2">
  <div>
    @if (auditQuestion.QuestionTypeID!=6) {
      <h2 class="text-green-700 md:text-2xl text-xl">{{auditQuestion.QuestionHeader}}</h2>
    }
    @if (auditQuestion.QuestionTypeID==6) {
      <h1 class="text-green-700 text-center text-xl">{{auditQuestion.QuestionHeader}}</h1>
    }
  </div>
  @if (auditQuestion.QuestionBody.length>0) {
    <div class="md:mt-3 mt-2">
      <h4>{{auditQuestion.QuestionBody}}</h4>
    </div>
  }
  @if (auditQuestion.HelpText.length>0) {
    <div class="md:mt-6 mt-2">
      <app-help-guidance [text]="auditQuestion.HelpText"></app-help-guidance>
    </div>
  }

  <div class="mt-6">
    @switch ( auditQuestion.QuestionTypeID) {
      @case (1) {
        <div>
          <app-radio-button [(currentQuestion)]="auditQuestion"></app-radio-button>
        </div>
      }
      @case (2) {
        <div><app-dropdown [(currentQuestion)]="auditQuestion"></app-dropdown></div>
      }
      @case (3) {
        <div><app-checkbox [(currentQuestion)]="auditQuestion"></app-checkbox></div>
      }
      @case (4) {
        <div><app-text [(currentQuestion)]="auditQuestion"></app-text></div>
      }
      @case (5) {
        <div>Comment Only</div>
      }
      @case (9) {
        <div><app-date  [(currentQuestion)]="auditQuestion" [includeTime]="false"></app-date></div>
      }
      @case (10) {
        <div><app-date  [(currentQuestion)]="auditQuestion" [includeTime]="true"></app-date></div>
      }
    }
  </div>
  @if (auditQuestion.AllowComments) {
    <div class="mt-8">
      <textarea placeholder="Comments" rows="5" [(ngModel)]="auditQuestion.Notes"></textarea>
    </div>
  }
</div>
